import { Injectable } from '@angular/core';
import { AnimalMediaCategoryModel } from '../models/animal-media-category.model';
import { HelperService } from 'src/app/shared/services/helper.service';
import { AnimalDocumentCategory } from '../models/animal-document-category.enum';

@Injectable({
  providedIn: 'root'
})
export class AnimalDocumentService {

  constructor(
    private readonly _helperService: HelperService
  ) {
  }

  getAnimalDocumentCategories(): AnimalMediaCategoryModel[] {
    return this._helperService.getEnumOptions(AnimalDocumentCategory, 'animal.documentCategory', true);
  }
}
